import { useSelector } from 'react-redux';

import OrdersActions from 'redux/actions/orders-actions/orders.actions';
import { dispatchAction as dpReduxAction } from 'business/shared/infra';
// TODO: move dispatchAction -> internal global redux and rename as dpReduxAction

import type { OrderId } from 'shared/domain';
import type { OrderDetailRawResp } from './orderToPrint.response';

function getOrderID(): OrderId {
  const orderId = useSelector(
    (s: any) => s.ordersReducer.orders.find((o: any) => o?.pendingToPrint)?.id,
  );
  return orderId ?? NaN;
}

function getIsRenderForced() {
  const LS_KEY = 'FORCE_RENDER_OF_ORDER_INVOICE_PRINTING';
  return window.sessionStorage.getItem(LS_KEY) === 'true';
}

function getOrderDetail(orderId: OrderId): OrderDetailRawResp | null {
  const orderRaw = useSelector((s: any) =>
    s.ordersReducer.orders.find(({ id }: { id: OrderId }) => id === orderId),
  );
  return orderRaw?.detail ?? null;
}

function updateOrderHasBeenPrinted(orderId: OrderId): void {
  dpReduxAction(OrdersActions.confirmPrint(orderId));
}

export const orderToPrintRepository = {
  getOrderID,
  getIsRenderForced,
  getOrderDetail,
  updateOrderHasBeenPrinted,
};
